"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Car = void 0;
var react_1 = __importDefault(require("react"));
var Car_module_scss_1 = __importDefault(require("./Car.module.scss"));
var extraInformation_json_1 = __importDefault(require("../credit/extraInformation.json"));
var BanksList_1 = require("../../components/banksList/BanksList");
var ButtonBoxCallCar_1 = require("../../components/buttonBoxCallCar/ButtonBoxCallCar");
var ButtonCard_1 = require("../../components/buttonCardOpenModal/ButtonCard");
var ButtonFavorite_1 = require("../../components/buttonFavorite/ButtonFavorite");
var CarCardSlider_1 = require("../../components/carCardSlider/CarCardSlider");
var CarEquipment_1 = require("../../components/carEquipment/CarEquipment");
var CarPrice_1 = require("../../components/carPrice/CarPrice");
var CarsSimilar_1 = require("../../components/carsSimilar/CarsSimilar");
var CheckHistory_1 = require("../../components/checkHistory/CheckHistory");
var ExtraInformation_1 = require("../../components/extraInformation/ExtraInformation");
var formatPrice_1 = require("../../helpers/formatPrice");
var getPayment_1 = require("../../helpers/car/getPayment");
var InStockSign_1 = require("../../components/inStockSign/InStockSign");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var transformPhoneNumber_1 = require("../../helpers/transformPhoneNumber");
var react_router_dom_1 = require("react-router-dom");
var customFetch_1 = require("../../helpers/customFetch");
var Loader_1 = require("../../components/loader/Loader");
var validateUrl_1 = require("../../helpers/validateUrl");
var BreadCrumpPage_1 = require("../../components/breadCrumpPage/BreadCrumpPage");
var Car = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var location = (0, react_router_dom_1.useLocation)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = react_1.default.useState(null), car = _a[0], setCar = _a[1];
    var _b = react_1.default.useState(false), isMobile = _b[0], setIsMobile = _b[1];
    var _c = react_1.default.useState('specs'), activeMobileTab = _c[0], setActiveMobileTab = _c[1];
    var unique_id = location.pathname.split('/')[3];
    var contacts = (0, react_redux_1.useSelector)(selectors_1.contactsSelector).contacts;
    react_1.default.useEffect(function () {
        (0, validateUrl_1.validateUrl)(location.pathname);
        var loadCarData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var encodedBrand, brand, loadCar, transormLoadCar, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((car === null || car === void 0 ? void 0 : car.unique_id) !== parseInt(unique_id))) return [3 /*break*/, 5];
                        encodedBrand = location.pathname.split('/')[2];
                        brand = decodeURIComponent(encodedBrand);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({
                                url: "cars/".concat(unique_id),
                                method: 'GET',
                            })];
                    case 2:
                        loadCar = _a.sent();
                        if ((loadCar === null || loadCar === void 0 ? void 0 : loadCar.brand.name) !== brand) {
                            navigate('/error');
                        }
                        transormLoadCar = __assign(__assign({}, loadCar), { brand: loadCar.brand.name });
                        setCar(transormLoadCar);
                        dispatch((0, modalSlice_1.setSelectCar)(transormLoadCar));
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Ошибка загрузки данных автомобиля:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        dispatch((0, modalSlice_1.setSelectCar)(car));
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        loadCarData();
    }, [unique_id, location.pathname]);
    react_1.default.useEffect(function () {
        var handleResize = function () { return setIsMobile(window.innerWidth <= 768); };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    if (!car) {
        return (react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "page" },
                react_1.default.createElement("div", { style: { marginTop: '50px' } },
                    react_1.default.createElement(Loader_1.Loader, null)))));
    }
    var brand = car.brand, body_type = car.body_type, color = car.color, model = car.model, description = car.description, year = car.year, price = car.price, gearbox_type = car.gearbox_type, drive_type = car.drive_type, history_cars = car.history_cars, engine_name_type = car.engine_name_type, engine_power_type = car.engine_power_type, engine_capacity_type = car.engine_capacity_type;
    var monthlyPaymentCompact = (0, getPayment_1.getPayment)(price, 0, 96, 4.9);
    var openModalCredit = function () {
        if (!car)
            return;
        dispatch((0, modalSlice_1.openModal)('credit'));
        dispatch((0, modalSlice_1.setSelectCar)(car));
    };
    var openModalExchange = function () {
        if (!car)
            return;
        dispatch((0, modalSlice_1.openModal)('exchange'));
        dispatch((0, modalSlice_1.setSelectCar)(car));
    };
    var characterInformation = [
        {
            title: 'Год выпуска',
            description: "".concat(year),
        },
        {
            title: 'КПП',
            description: "".concat(gearbox_type.abbreviation),
        },
        {
            title: 'Пробег',
            description: "".concat((0, formatPrice_1.formatPrice)(history_cars[0].last_mileage), " \u043A\u043C."),
        },
        {
            title: 'Объем двигателя',
            description: "".concat(engine_capacity_type.capacity, " \u043B."),
        },
        {
            title: 'Мощность двигателя',
            description: "".concat(engine_power_type.power, "\u043B.\u0441."),
        },
        {
            title: 'Тип двигателя',
            description: "".concat(engine_name_type.name),
        },
        {
            title: 'Тип кузова',
            description: "".concat(body_type.name),
        },
        {
            title: 'Привод',
            description: "".concat(drive_type.name),
        },
        {
            title: 'Цвет кузова',
            description: "".concat(color.name),
        },
        {
            title: 'Владельцев',
            description: "".concat(history_cars[0].previous_owners),
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "page" },
                react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: [
                        { name: 'Главная', url: '/' },
                        { name: 'С пробегом', url: '/cars' },
                        { name: "".concat(brand), url: "/cars?brand_name=".concat(brand, "&price_asc=true") },
                        {
                            name: "".concat(model.name),
                            url: "/cars?brand_name=".concat(brand, "&model_name=").concat(model.name, "&price_asc=true"),
                        },
                        {
                            name: "".concat(brand, " ").concat(model.name),
                            url: "",
                        },
                    ] }),
                react_1.default.createElement("h1", { className: "page__title" },
                    typeof brand === 'string' ? brand : brand.name,
                    " ",
                    model.name,
                    " ",
                    description,
                    " ",
                    year,
                    " \u0433\u043E\u0434\u0430"),
                react_1.default.createElement("div", { className: Car_module_scss_1.default.car__main },
                    react_1.default.createElement("aside", { className: Car_module_scss_1.default.car__aside },
                        react_1.default.createElement("div", { className: Car_module_scss_1.default.car__aside_buy },
                            react_1.default.createElement("div", { className: Car_module_scss_1.default.price },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(CarPrice_1.CarPrice, { price: price })),
                                react_1.default.createElement(ButtonFavorite_1.ButtonFavorite, { car: car })),
                            react_1.default.createElement("div", { className: Car_module_scss_1.default.car__modal_buttons },
                                react_1.default.createElement(ButtonCard_1.ButtonCardOpenModal, { textContent: "\u041A\u0443\u043F\u0438\u0442\u044C \u0432 \u043A\u0440\u0435\u0434\u0438\u0442", handler: openModalCredit, extraClassName: Car_module_scss_1.default.car__modal_button_credit }),
                                react_1.default.createElement(ButtonCard_1.ButtonCardOpenModal, { textContent: "\u0422\u0440\u0435\u0439\u0434-\u0438\u043D", handler: openModalExchange, className: Car_module_scss_1.default.car__modal_button_trade })),
                            react_1.default.createElement(ButtonBoxCallCar_1.ButtonBoxCallCar, null)),
                        react_1.default.createElement(CheckHistory_1.CheckHistory, __assign({}, car)),
                        isMobile ? (react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: Car_module_scss_1.default.car__mobile_tabs },
                                react_1.default.createElement("button", { type: "button", className: "".concat(Car_module_scss_1.default.car__mobile_tab, " ").concat(activeMobileTab === 'specs' ? Car_module_scss_1.default.car__mobile_tab_active : ''), onClick: function () { return setActiveMobileTab('specs'); } }, "\u0425\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438"),
                                react_1.default.createElement("button", { type: "button", className: "".concat(Car_module_scss_1.default.car__mobile_tab, " ").concat(activeMobileTab === 'credit' ? Car_module_scss_1.default.car__mobile_tab_active : ''), onClick: function () { return setActiveMobileTab('credit'); } }, "\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u0430")),
                            react_1.default.createElement("div", { className: Car_module_scss_1.default.car__mobile_panel }, activeMobileTab === 'specs' ? (react_1.default.createElement(ExtraInformation_1.ExtraInformation, { title: "\u0425\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438", information: characterInformation })) : (react_1.default.createElement(ExtraInformation_1.ExtraInformation, __assign({}, extraInformation_json_1.default)))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(ExtraInformation_1.ExtraInformation, { title: "\u0425\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438", information: characterInformation }),
                            react_1.default.createElement(ExtraInformation_1.ExtraInformation, __assign({}, extraInformation_json_1.default)))),
                        react_1.default.createElement(CarEquipment_1.CarEquipment, { car: car })),
                    react_1.default.createElement("div", { className: Car_module_scss_1.default.car__content },
                        react_1.default.createElement("div", { className: Car_module_scss_1.default.car__content_inner },
                            react_1.default.createElement(InStockSign_1.InStockSign, { state: car.online_view_available, extraClassName: Car_module_scss_1.default.in_stock_sign }),
                            react_1.default.createElement(CarCardSlider_1.CarCardSlider, { images: car.images }),
                            react_1.default.createElement("div", { className: Car_module_scss_1.default.car__callback },
                                react_1.default.createElement("div", { className: Car_module_scss_1.default.car__callback_price },
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement(CarPrice_1.CarPrice, { price: price })),
                                    react_1.default.createElement(ButtonCard_1.ButtonCardOpenModal, { textContent: "\u041A\u0443\u043F\u0438\u0442\u044C \u0432 \u043A\u0440\u0435\u0434\u0438\u0442", handler: openModalCredit, extraClassName: Car_module_scss_1.default.car__modal_button_credit })),
                                react_1.default.createElement(ButtonBoxCallCar_1.ButtonBoxCallCar, { extraStyles: { gap: '8px', padding: '0px' } }))))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h2", { className: Car_module_scss_1.default.car__subtitle }, "\u0411\u0430\u043D\u043A\u0438-\u043F\u0430\u0440\u0442\u043D\u0435\u0440\u044B"),
                    react_1.default.createElement(BanksList_1.BanksList, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h2", { className: Car_module_scss_1.default.car__subtitle }, "\u041F\u043E\u0445\u043E\u0436\u0438\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438"),
                    react_1.default.createElement(CarsSimilar_1.CarsSimilar, { car: car })))),
        isMobile ? (react_1.default.createElement("div", { className: Car_module_scss_1.default.car__sticky_bar },
            react_1.default.createElement("div", { className: Car_module_scss_1.default.car__sticky_top },
                react_1.default.createElement("div", { className: Car_module_scss_1.default.car__sticky_price_box },
                    react_1.default.createElement("div", { className: Car_module_scss_1.default.car__sticky_price },
                        (0, formatPrice_1.formatPrice)(price),
                        " \u20BD"),
                    react_1.default.createElement("div", { className: Car_module_scss_1.default.car__sticky_month },
                        (0, formatPrice_1.formatPrice)(monthlyPaymentCompact),
                        " \u20BD/\u043C\u0435\u0441")),
                react_1.default.createElement(ButtonCard_1.ButtonCardOpenModal, { textContent: "\u041A\u0443\u043F\u0438\u0442\u044C \u0432 \u043A\u0440\u0435\u0434\u0438\u0442", handler: openModalCredit, extraClassName: "".concat(Car_module_scss_1.default.car__modal_button_credit, " ").concat(Car_module_scss_1.default.car__sticky_credit_btn) })),
            react_1.default.createElement("div", { className: Car_module_scss_1.default.car__sticky_divider }),
            react_1.default.createElement("div", { className: Car_module_scss_1.default.car__sticky_bottom },
                react_1.default.createElement("button", { className: Car_module_scss_1.default.car__sticky_call_btn, type: "button", onClick: function () { return dispatch((0, modalSlice_1.openModal)('callback')); } }, "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u044C"),
                react_1.default.createElement("a", { className: Car_module_scss_1.default.car__sticky_phone, href: "tel: +".concat(contacts.phone) }, (0, transformPhoneNumber_1.transformPhoneNumber)(contacts.phone))))) : null));
};
exports.Car = Car;
